export const DEFAULT_PAGINATION = {
  size: 10,
  page: 1
}